import { Role } from '../interfaces/candidates';

const isAccessAllowed = (requiredRoles: Array<string>, role?: Role) => {
  if (!role) return;

  return requiredRoles.some((requiredRole) => role.systemRole === requiredRole);
};

export default isAccessAllowed;
